// EMPLOYMENT_TYPE_CONFIG and REQUISITION_TYPE_CONFIG live in the shared
// constants layer; imported for the local OPTIONS derivation below and
// re-exported for existing within-feature callers.
import {
  EMPLOYMENT_TYPE_CONFIG,
  REQUISITION_TYPE_CONFIG,
} from '@/constants/requisition-constants';

// Backend enum values - these should match your backend exactly
export const BACKEND_ENUMS = {
  employment_type: {
    full_time: 0,
    part_time: 1,
    contract: 2,
    internship: 3,
    temporary: 4,
    seasonal: 5,
    consultant: 7,
    apprentice: 8,
  },
  requisition_type: {
    new_hire: 0,
    backfill: 2,
    internal: 4,
  },
} as const;

// Type definitions derived from backend enums
export type EmploymentType = keyof typeof BACKEND_ENUMS.employment_type;
export type RequisitionType = keyof typeof BACKEND_ENUMS.requisition_type;

// Mappings for form submission (same as backend values)
export const EMPLOYMENT_TYPE_MAPPING = BACKEND_ENUMS.employment_type;
export const REQUISITION_TYPE_MAPPING = BACKEND_ENUMS.requisition_type;

// EMPLOYMENT_TYPE_CONFIG and REQUISITION_TYPE_CONFIG re-exported from the
// shared constants layer.
export { EMPLOYMENT_TYPE_CONFIG, REQUISITION_TYPE_CONFIG };

// Form options for dropdowns
export const EMPLOYMENT_TYPE_OPTIONS = Object.keys(EMPLOYMENT_TYPE_CONFIG).map(
  (key) => ({
    label: EMPLOYMENT_TYPE_CONFIG[key as EmploymentType].label,
    value: key as EmploymentType,
  })
);

export const REQUISITION_TYPE_OPTIONS = Object.keys(
  REQUISITION_TYPE_CONFIG
).map((key) => ({
  label: REQUISITION_TYPE_CONFIG[key as RequisitionType].label,
  value: key as RequisitionType,
}));

// Default values
export const ENUM_DEFAULTS = {
  employment_type: 'full_time' as EmploymentType,
  requisition_type: 'new_hire' as RequisitionType,
} as const;
